// Entry for every inner page (Work, Services, Studio, Lab, Journal, Careers, Contact and their subpages).
// The home page uses main.ts (hero, WebGL, TV); inner pages only need the shared site shell + components.
import './styles/main.css';
import { initScroll } from './core/scroll';
import { initTheme } from './core/theme';
import { initCursor } from './modules/cursor';
import { initComponents } from './modules/components';
import { initStyleLens } from './modules/styleLens';
import { initFooter } from './modules/footer';
import { initNavMenu, initScrollReveal, initAnchorScroll, initContactForm, initEnquire, initMagnetText, initButtonLetters } from './modules/ui';

initScroll();
initTheme();
initCursor();
initMagnetText();
initButtonLetters();
initNavMenu();
initAnchorScroll();
initContactForm();
initComponents();
initStyleLens(); // Lab page only (no-op without #skills .lens-rail)
initScrollReveal();
initFooter();
document.querySelectorAll('[data-year]').forEach((el) => { el.textContent = String(new Date().getFullYear()); });
